export enum UserRole {
  Planificateur = 'PLANIFICATEUR',
  Conducteur = 'CONDUCTEUR',
}
